
import { Config__get_TestHooks, Config__get_BuildId, Config__get_ApiKey, Config__get_ApiBaseUrl, load } from "./Environment.js";
import { Elm } from "../Main.elm";
import { InitOptions, Flags } from "./Elm.js";
import { connect } from "./ArInterop.js";
import { mountQualificationCapture } from "../qualification-capture.js";
import "../styles.css";


const config = load();

export const app = Elm.Main.init(new InitOptions(document.getElementById("elm"), new Flags(Config__get_ApiBaseUrl(config), Config__get_ApiKey(config), Config__get_BuildId(config))));

connect(app, Config__get_TestHooks(config));

app.ports.copyText.subscribe((text) => {
    navigator.clipboard?.writeText(text)?.catch(() => {});
});

mountQualificationCapture();

//# sourceMappingURL=Program.js.map
